import React, { useState } from 'react';
import ImageLogo from "../assets/images/star123-logo.webp"
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faMobileScreenButton } from '@fortawesome/free-solid-svg-icons';
import { openStar123Download } from '../hooks/useMobileInstallPrompt';

function Header({ link }) {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleGetApp = (event) => {
        event.preventDefault();
        handleCloseMenu();
        openStar123Download({ appLink: link });
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleCloseMenu = () => {
        setIsMenuOpen(false)
    }


    return (
        <nav className="navbar navbar-expand-lg py-lg-3 navbar-light custom__nav">
            <div className="container-fluid navbar-cluster">
                <div className="navbar-cluster__ribbon">
                    <NavLink className="navbar-brand mb-0 py-0" to="/" onClick={() => navigate('/')}>
                        <img
                            alt="Star123 Official logo"
                            fetchPriority="high"
                            width={180}
                            height={120}
                            decoding="async"
                            className="topbar-logo"
                            style={{ color: "transparent" }}
                            src={ImageLogo}
                        />
                    </NavLink>
                    <button
                        className={"navbar-toggler" + ((!isMenuOpen) ? " collapsed" : "")}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={() => toggleMenu()}
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                    <div
                        className={"collapse navbar-collapse header-link flex-grow-1 flex-lg-grow-0" + (isMenuOpen ? " show" : "")}
                        id="navbarSupportedContent"
                    >
                        <ul className="navbar-nav navbar-nav-cluster d-flex flex-column flex-lg-row align-items-center justify-content-center mt-lg-0 mt-3 mb-lg-0">
                        <li className="nav-item">
                            <NavLink
                                to={"/"}
                                className={({ isActive }) => (isActive ? 'active-link nav-link menu-link fw-normal' : 'nav-link menu-link fw-normal')}
                                onClick={handleCloseMenu}
                            >
                                Home
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink
                                to={"/charts"}
                                className={({ isActive }) => (isActive ? 'active-link nav-link menu-link fw-normal' : 'nav-link menu-link fw-normal')}
                                onClick={handleCloseMenu}
                            >
                                Charts
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink
                                to={"/chart/starline"}
                                className={({ isActive }) => (isActive ? 'active-link nav-link menu-link fw-normal' : 'nav-link menu-link fw-normal')}
                                onClick={handleCloseMenu}
                            >
                                Starline
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink
                                to={"/chart/jackpot"}
                                className={({ isActive }) => (isActive ? 'active-link nav-link menu-link fw-normal' : 'nav-link menu-link fw-normal')}
                                onClick={handleCloseMenu}
                            >
                                Jackpot
                            </NavLink>
                        </li>

                        <li id="getAppNavLink" className="nav-item nav-item-get-app">
                            <a
                                style={{ color: "white" }}
                                className="nav-link d-inline-flex align-items-center gap-2 text-white text-decoration-none button__app__wrapper py-2 px-3"
                                href={link || '#'}
                                onClick={handleGetApp}
                            >
                                <FontAwesomeIcon
                                    icon={faMobileScreenButton}
                                    className="get-free-app-icon"
                                    aria-hidden
                                />
                                <span className="button__app">Get Free App</span>
                            </a>
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>

    );
}

export default Header;
